export default __webpack_public_path__ + "static/ic_webinar_iso_9001-467aa35a409df74fdc777f8bb16e381e.svg";